import styled from 'styled-components';
import { Button } from 'antd';

export const PdfButton = styled(Button)`
	height: 40px;
	width: fit-content;
	border-radius: 4px;
	background-color: ${({ theme }) => theme.palette.secondary.white};
`;

export const ConsolidateButton = styled(Button)`
	height: 40px;
	width: fit-content;
	color: ${({ theme }) => theme.palette.risk.low.default};
	border-radius: 4px;
	border: 1px solid transparent;
	background: ${({ theme }) => theme.palette.risk.low[100]};

	.anticon {
		color: ${({ theme }) => theme.palette.risk.low.default};
	}

	&:hover {
		background-color: ${({ theme }) => theme.palette.risk.low[100]};
		border: 1px solid ${({ theme }) => theme.palette.risk.low.default};
		color: ${({ theme }) => theme.palette.risk.low.default};
	}

	&:disabled {
		.anticon {
			color: ${({ theme }) => theme.palette.secondary[250]} !important;
		}
	}
`;

export const DeconsolidateButton = styled(Button)`
	height: 40px;
	width: fit-content;
	color: ${({ theme }) => theme.palette.secondary[300]};
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.palette.secondary[300]};

	.anticon {
		color: ${({ theme }) => theme.palette.secondary[300]};
	}

	&:hover {
		background-color: ${({ theme }) => theme.palette.secondary[100]};
		border: 1px solid ${({ theme }) => theme.palette.secondary[300]};
		color: ${({ theme }) => theme.palette.secondary[300]};
	}

	&:disabled {
		.anticon {
			color: ${({ theme }) => theme.palette.secondary[250]} !important;
		}
	}
`;
